/* eslint-disable no-nested-ternary */
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Link from '../../../Core/Link';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: ${props => (props.image ? `url(${props.image}` : 'none')};
  background-size: 38%;
  background-position: top right;
  background-repeat: no-repeat;
  background-color: ${props =>
    props.backgroundColor
      ? themeGet(`colors.${props.backgroundColor}`)
      : 'transparent'};

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex-direction: row;
    background-size: 32%;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    height: 300px;
  }
`;

export const Content = styled.div`
  width: 100%;
  padding: 4rem 1rem 9rem;
  margin: 0 auto;
  text-align: center;
  color: ${props =>
    props.backgroundColor === 'velvet'
      ? themeGet('colors.white')
      : props.backgroundColor === 'pc-red'
        ? themeGet('colors.white')
        : themeGet('colors.main-text')};

  @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
    padding: 4rem 1rem 8rem;
  }

  @media only screen and (min-width: ${themeGet(
      'breakpoints.sm',
    )}) and (orientation: landscape) {
    padding: 4rem 1rem 15rem;
  }

  @media only screen and (min-width: ${themeGet(
      'breakpoints.sm',
    )}) and (max-height: 320px) and (orientation: landscape) {
    padding: 4rem 1rem 16rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 65%;
    padding: 3rem 1rem 3rem 3rem;
    text-align: left;
  }

  @media only screen and (min-width: 812px) and (max-height: 411px) and (orientation: landscape) {
    padding: 6rem 1rem 6rem 3rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 9rem 1rem 9rem 3rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    width: 70%;
  }
`;

export const Title = styled.h1`
  color: inherit;
  font-size: 2.5rem;
  line-height: 1.1;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    line-height: 1.2;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    font-size: 4rem;
  }
`;

export const SubHead = styled.p`
  color: inherit;
  margin-top: 1rem;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    font-size: 1.125rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    font-size: 1.25rem;
  }
`;

export const CardWrapper = styled.div`
  display: flex;
  text-align: center;
  align-items: center;
  position: relative;
  justify-content: center;
  width: 75%;
  clear: both;
  bottom: -2rem;
  margin: 0 auto;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    bottom: -3.5rem;
    width: 35%;
    margin-right: 3rem;
    justify-content: flex-end;
  }

  @media only screen and (min-width: 812px) and (max-height: 411px) and (orientation: landscape) {
    bottom: -4.5rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    bottom: -4.5rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    width: 30%;
  }

  .container {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .img1,
  .img2,
  .img3 {
    width: 100%;
    max-width: 330px;
    margin: 0 auto;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      max-width: 270px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      max-width: 320px;
    }

    img {
      width: 100%;
    }
  }

  .img1,
  .img2 {
    position: absolute;
    right: 0;
    left: 0;
  }

  .img1 {
    bottom: 7rem;
    z-index: 3;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      bottom: 8.75rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      bottom: 11rem;
    }
  }

  .img2 {
    bottom: 3.5rem;
    z-index: 2;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      bottom: 4.5rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      bottom: 5.5rem;
    }
  }

  .img3 {
    position: relative;
    z-index: 1;
  }
`;

export const StyledLink = styled(Link)`
  span {
    font-size: 14px;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      font-size: 16px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      font-size: 18px;
    }
  }
`;

export const CtaContainer = styled.div`
  display: flex;
  flex-direction: row;
  text-align: center;
  padding: 4rem 0 2rem;
  margin: 0 auto;
  justify-content: center;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 2rem 0 2rem 3rem;
    justify-content: flex-start;
  }

  a {
    min-width: 200px;

    @media only screen and (min-width: 340px) {
      min-width: 250px;
    }
  }
`;
